"use strict";

import React from "react";
import { translate } from "react-i18next";

const year = new Date().getFullYear();

class Footer extends React.Component {
  render() {
    // const { t } = this.props
    // const coords = '45.4172804,10.401548100000014'
    let classes = "";
    if (this.props.noSticky) classes += "no-sticky";
    if (this.props.fullWidth) classes += "w-100";

    return (
      <footer className={classes}>
        <p>
          info@neeruweb.com - NEERU SRL, LEGNANO (MI) VIA XX SETTEMBRE 30 20025
          | VAT: 13685910963 <br />
          <a href={process.env.PRIVACY_URL} target="_blank" className="u-white">
            Privacy Policy
          </a>{" "}
          | Copyright {year}
        </p>
      </footer>
    );
  }
}

export default translate(["common"])(Footer);



// WEBPACK FOOTER //
// src/components/Footer.js